import { TimePicker, TimePickerProps } from '@material-ui/pickers';

export const RegionTimeWindowTimePicker = (props: TimePickerProps) => {
  return <TimePicker format="hh:mm a" {...props} />;
};
